import { applySpec, prop, pipe } from 'ramda';

const toNumber = (value) => Number.parseInt(value, 10);

export default applySpec({
	id: prop('ID'),
	name: prop('NAME'),
	price: pipe(prop('PRICE'), toNumber),
	priceBrand: pipe(prop('PRICE_BRAND'), toNumber),
});
